import { UserDetailService } from './../../../shared/services/user-detail.service';
import { AuthUserEntity } from './../../../types/AuthUser';
import { map, tap } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthService } from './../auth.service';
import { Injectable } from "@angular/core";
import { AuthActions } from './action-typs';
import { Router } from '@angular/router';

@Injectable()
export class AuthEffcts {


    loginEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.login),
            tap((action: any) => {
                localStorage.setItem("USER", JSON.stringify(action?.authUser));
                // Clear impersonation flags only for non-super users who aren't impersonating
                const isImpersonating = localStorage.getItem('superUser') === 'true';
                if (!isImpersonating && action?.authUser?.userType !== 20 && !['20', '21', '22', '23'].includes(action?.authUser?.roleType)) {
                    localStorage.removeItem('superUser');
                    localStorage.removeItem('impersonatedEmail');
                    localStorage.removeItem('impersonatedName');
                }
                this.userService.setUserDetails(action.authUser);
            })
        ), { dispatch: false }
    );
    logoutEffect$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(AuthActions.logout),
                tap(action => {
                    localStorage.removeItem('USER');
                    localStorage.removeItem('superUser');
                    localStorage.removeItem('impersonatedEmail');
                    localStorage.removeItem('impersonatedName');
                    localStorage.removeItem('postGreParentClubId');
                    localStorage.removeItem('SECURE_TOKEN');
                    this.authService.clearTokens();
                    this.router.navigateByUrl('/auth/login');
                })
            )
        , { dispatch: false });

    constructor(private authService: AuthService, private actions$: Actions, private router: Router,private userService:UserDetailService) { }



}